/*
 * Video Player
 *
 * @author Nalin Ahuja
 * @created 2013-09-19
 */
import Browser from '../Browser'
import VRVideoPlayer from './vrVideoPlayer'
import EventEmitter from '../vendor/EventEmitter'
import PLAY from 'public/assets/svg/icons/icon_videoui_play.raw.svg'
import PAUSE from 'public/assets/svg/icons/icon_videoui_pause.raw.svg'
import AUDIO_ON from 'public/assets/svg/icons/icon_videoui_audio.raw.svg'
import AUDIO_OFF from 'public/assets/svg/icons/icon_videoui_audio_off.raw.svg'
import SETTINGS from 'public/assets/svg/icons/icon_settings.raw.svg'
import FULLSCREEN from 'public/assets/svg/icons/icon_fullscreen.raw.svg'
import FULLSCREEN_OFF from 'public/assets/svg/icons/icon_fullscreen_exit.raw.svg'
import $ from 'jquery'
import ApiResource from '../utils/apiResource'
import Cookie from 'aria-viewer/utils/cookie'
import { DeviceGrades } from 'aria-viewer/device/deviceDetection'

var VideoPlayer = function(options) {
    var self = this
    // private members
    this._globalPlayer = null

    // event listeners
    // for library reference look up EventEmitter.js or https://github.com/Olical/EventEmitter/blob/master/docs/api.md
    this._eventEmitter = new EventEmitter()

    // Assign default option values for missing options
    this.options = Object.create(defaultOptions)
    for (var name in options) {
        if (options[name] !== null && typeof options[name] != 'undefined') {
            this.options[name] = options[name]
        }
    }

    // public members
    this.type = this.options.type
    this.id = this.options.videoId
    this.videoIndex = videoIndex++
    this.playback_type = this.options.playback_type
    this.container = null
    this.instructionIndex = this.options.instructionIndex || 1000
    VideoPlayer.players[this.getDOMId()] = this //used for global function calls
    this.hideUI = options.hideUI
    this.controls = options.controls !== false
    this.background = !this.controls
    this.loop = options.loop === true
    this.mouse = {}
    this.uiBottomOffset = options.uiBottomOffset || '5px'
    this.deviceGrade = options.deviceGrade || DeviceGrades.NOT_TESTED

    //this flags wether or not to show the drag hint on load
    this.disableShowDragHintOnLoad = options.disableShowDragHintOnLoad || false
}

VideoPlayer.projections = {
    EQUIRECTANGULAR: 'equirectangular',
    EASY: 'easy',
    NONE: '',
}

VideoPlayer.events = {
    LOADED: 'loaded',
    PLAY: 'play',
    TOGGLE: 'toggle',
    PAUSE: 'pause',
    READY: 'ready',
    FINISH: 'finish',
    PLAY_PROGRESS: 'playProgress',
    LOAD_PROGRESS: 'loadProgress',
    FULLSCREEN: 'fullscreen',
    UI_HIDDEN: 'uihidden',
    UI_SHOWN: 'uishown',
    SKIP: 'skip',
    ERROR: 'error',
    ENDED: 'ended',
    TIMEUPDATE: 'timeupdate',
    DRAGEND: 'dragend',
    DRAGSTART: 'dragstart',
}

VideoPlayer.isMobile = function() {
    return (
        $(window).width() <= 768 ||
        Browser.is('mobile') ||
        (window.location.search.includes && window.location.search.includes('mobile=1'))
    )
}

VideoPlayer.prototype.setVolume = function(level) {
    if (level) {
        $(this.container)
            .find('.audio')
            .show()
        $(this.container)
            .find('.audio_off')
            .hide()
    } else {
        $(this.container)
            .find('.audio')
            .hide()
        $(this.container)
            .find('.audio_off')
            .show()
    }
}

VideoPlayer.players = {}

VideoPlayer.types = {
    YOUTUBE: 'youtube',
    VIMEO: 'vimeo',
    AWS: 'aws',
}

VideoPlayer.playbackTypes = {
    FLAT: 'flat',
    THREE_SIXTY: '360',
}

/*
 * PRIVATE MEMBERS
 */
var videoIndex = 0,
    playerData = {
        playerType: '',
        width: '',
        height: '',
        videoID: '',
        autoplay: '1',
        domId: '',
    },
    defaultOptions = {
        playback_type: VideoPlayer.playbackTypes.FLAT,
        autoplay: false,
        accessPlayerAPI: true,
    }

//////////////////////////////////////////////////////
//////////////// STATIC FUNCTIONS ////////////////////
//////////////////////////////////////////////////////
///
/*
 * Creates a new VideoPlayer object. The specific implementation class
 * will be dependent on the videoType and playback_type. The options list
 * include:
 * - videoId (required), video ID
 * - type: (required), VideoPlayer.types
 * - playback_type: VideoPlayer.playbackTypes. Default value is FLAT
 * - autoplay: (true/false). Default value is false
 * - accessPlayerAPI: (true, false). Enables the user to control
 *     the video player using JS with playback options. It also adds
 *     listeners to playback events. Default value is false
 */
VideoPlayer.createPlayer = function(options) {
    if (options === undefined || options.videoId === undefined || options.type === undefined) {
        throw {
            name: 'InvalidUsage',
            message: 'Cannot create a video without a video ID and type set',
        }
    }
    if (!options.playback_type || options.playback_type == VideoPlayer.playbackTypes.FLAT) {
        if (options.type === VideoPlayer.types.YOUTUBE) {
            return new YoutubePlayer(options)
        } else if (options.type === VideoPlayer.types.VIMEO) {
            return new VimeoPlayer(options)
        } else if (options.type === VideoPlayer.types.AWS) {
            return new AwsPlayer(options)
        }
    } else {
        return new VRPlayer(options)
    }
}

VideoPlayer.quality = function(id, value) {
    var player = VideoPlayer.getPlayer(id)
    var q = $(player.container).find('.qualities')
    if (value) {
        player.setQuality(value)
        player.qualitiesTimeout = null
        q.fadeOut()
    } else {
        if (q.is(':visible')) {
            player.qualitiesTimeout = null
            return q.fadeOut()
        }
        player.showQualities()
    }
}

/**
 * makes this video player fullscreen, or exits fullscreen if already
 * @param  {String} id of the video player to fullscreen
 */
VideoPlayer.fullscreen = function(id) {
    VideoPlayer.getPlayer(id).fullscreen()
}

VideoPlayer.volume = function(id) {
    var player = VideoPlayer.getPlayer(id)
    player.getVolume(function(volume) {
        player._onVolume(volume, true)
    })
}

VideoPlayer.toggleVolume = function(id) {
    var player = VideoPlayer.getPlayer(id)
    player.getVolume(function(volume) {
        // if undefined, just set it to what it is now:
        if (typeof player._lastVolume === 'undefined') player._lastVolume = volume

        window.pl = player
        window.plvol = volume

        // if the volume is 0, set the volume to whatever it used to be
        if (volume == 0) player.setVolume(player._lastVolume)
        else {
            player._lastVolume = volume
            player.setVolume(0)
        }
    })
}

/**
 * sets up this player for setting progress
 * @param  {String} id of video player to start progress change
 */
VideoPlayer.mousedown = function(id, down, event) {
    var player = VideoPlayer.getPlayer(id)
    if (down === 'video_progress') {
        player.pause()
    }
    player.mouse.down = down
    player._onMouseMove(event)
    event.preventDefault()
    return false
}

/**
 * changes the play / pause state of the video by id
 * @param  {String} id of the dom element
 */
VideoPlayer.togglePlaying = function(id) {
    var player = VideoPlayer.getPlayer(id)
    player.togglePlaying()
}

/**
 * plays the video by id
 * @param  {String} id of dom element
 */
VideoPlayer.play = function(id) {
    VideoPlayer.getPlayer(id).play()
}

/**
 * pauses the video by id
 * @param  {String} id of dom element
 */
VideoPlayer.pause = function(id) {
    VideoPlayer.getPlayer(id).pause()
}

/**
 * gets the video by id
 * @param  {String} id of dom element
 */
VideoPlayer.getPlayer = function(id) {
    return VideoPlayer.players[id]
}

VideoPlayer.introVideoComplete = function(id) {
    var player = VideoPlayer.getPlayer(id)
    player.trigger(VideoPlayer.events.SKIP)
}

VideoPlayer.showIntroPrompt = function(id) {
    // find the UI elements that belong to this player
    var UIDom = $('#' + id)
        .parent()
        .find('.video_ui_overlay')
    UIDom.find('.video_skip').addClass('prompt')
}

/**
 * Binds events for video ui controls
 * @param {String} id of dom element
 */
VideoPlayer.bindUIEvents = function(id, listenerDOMId) {
    // get the current player
    var player = VideoPlayer.getPlayer(id)

    // find the UI elements that belong to this player
    var UIDom = $('#' + id)
            .parent()
            .find('.video_ui_overlay'),
        container = listenerDOMId !== '' ? $('#' + listenerDOMId) : UIDom

    if (player.playback_type === VideoPlayer.playbackTypes.FLAT) {
        UIDom.addClass('flat')
    }

    if (
        (player.type == VideoPlayer.types.VIMEO ||
            player.type == VideoPlayer.types.YOUTUBE ||
            player.type == VideoPlayer.types.AWS) &&
        !player.options.noPointerEvents
    ) {
        UIDom.addClass('pointer-all')
    }

    // toggle playing when play/pause button is clicked
    UIDom.find('.playbutton').on('click', function() {
        VideoPlayer.togglePlaying(id)
    })

    // not really sure what this does - it was moved over from the original code.
    UIDom.find('.qualities').mousemove(function() {
        player.showQualities()
    })

    // volume slider controlers
    UIDom.find('.volume_container, .volume_container .volume')
        .on('mousedown touchstart', function(event) {
            VideoPlayer.mousedown(id, 'volume', event)
        })
        .mouseover(function() {
            player._showVolume()
        })
        .mouseout(function() {
            player._setVolumeTimeout()
        })

    // when mouse down on video progress we can save the mouse state so the mousemove events
    // will adjust the progress later
    UIDom.find('.video_progress').on('mousedown touchstart', function(event) {
        VideoPlayer.mousedown(id, 'video_progress', event)
    })

    // audio button: must show volume on hover, toggle volume on click
    UIDom.find('.right_panel .audio_control')
        .mouseover(function() {
            //VideoPlayer.volume(id);
            player._showVolume()
            $('.volume').focus()
        })
        .mouseout(function() {
            player._setVolumeTimeout()
        })
        .on('click', function() {
            player._showVolume()
            VideoPlayer.toggleVolume(id)
            player._showVolume()
        })

    // when settings button is pushed
    UIDom.find('.right_panel .settings_button').on('click', function() {
        VideoPlayer.quality(id)
    })

    // when full screen is pushed
    UIDom.find('.right_panel .fulscr').on('click', function() {
        VideoPlayer.fullscreen(id)
    })

    // when showing intro media, give the user the option to skip
    UIDom.find('.video_skip').on('click', function() {
        VideoPlayer.introVideoComplete(id)
    })

    this._docFSBind = player._onFullscreen.bind(player)
    this._windMMBind = player._onMouseMove.bind(player)
    this._windMDBind = player._onMouseDown.bind(player)
    this._windMUBind = player._onMouseUp.bind(player)
    this._windRSBind = player._onWindowResize.bind(player)
    $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', this._docFSBind)
    // when there's any global mouse movements, we should capture them for our controls
    container.on('mousemove touchmove', this._windMMBind)
    container.on('mousedown touchstart', this._windMDBind)
    container.on('mouseup touchend', this._windMUBind)
    $(window).on('resize', this._windRSBind)
}

/**
 * unBinds events for video ui controls
 * @param {String} id of dom element
 */
VideoPlayer.unbindUIEvents = function(id, listenerDOMId) {
    // get the current player
    var player = VideoPlayer.getPlayer(id)

    // find the UI elements that belong to this player
    var UIDom = $('#' + id)
            .parent()
            .find('.video_ui_overlay'),
        container = listenerDOMId !== '' ? $('#' + listenerDOMId) : UIDom

    UIDom.find('.playbutton').off()
    UIDom.find('.qualities').off()
    UIDom.find('.volume_container, .volume_container .volume').off()
    UIDom.find('.video_progress').off()
    UIDom.find('.right_panel .audio_control').off()
    UIDom.find('.right_panel .settings_button').off()
    UIDom.find('.right_panel .fulscr').off()
    UIDom.find('.video_skip').off()

    $(document).off('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', this._docFSBind)
    container.off('mousemove touchmove', this._windMMBind)
    container.off('mousedown touchstart', this._windMDBind)
    container.off('mouseup touchend', this._windMUBind)
    this._windRSBind && $(window).off('resize', this._windRSBind)
    this._docFSBind = this._windMMBind = this._windMDBind = this._windMUBind = null
}

//////////////////////////////////////////////////////
//////////////// MEMBER FUNCTIONS ////////////////////
//////////////////////////////////////////////////////

VideoPlayer.prototype.getDuration = function(callback) {
    return 0
}

VideoPlayer.prototype.getCurrentTime = function() {
    return 0
}

VideoPlayer.prototype.getBuffered = function() {
    return 0
}

VideoPlayer.prototype.setVolume = function(level) {
    if (level) {
        $(this.container)
            .find('.audio')
            .show()
        $(this.container)
            .find('.audio_off')
            .hide()
    } else {
        $(this.container)
            .find('.audio')
            .hide()
        $(this.container)
            .find('.audio_off')
            .show()
    }
}
/*
 * Embeds the video player under the given container with the designated
 * width and height
 */
VideoPlayer.prototype.embedPlayer = function(container, width, height) {
    var self = this

    if (self._globalPlayer !== null) {
        throw {
            name: 'InvalidUsage',
            message: 'Error: You can only addVideo once',
        }
    }

    container = self._embedPlayer(container, width, height)

    if (self.options.accessPlayerAPI) {
        self._addPlayerAPI(container, width, height)
    } else {
        // If we cannot access player API then fire on ready event. Otherwise, the API will
        // call the function for us
        self._onReadyCb()
    }

    return self
}

VideoPlayer.prototype.isPanoramicVideo = function() {
    return this.playback_type != VideoPlayer.playbackTypes.FLAT
}

VideoPlayer.prototype.showVideoUI = function(offUI) {
    var self = this
    $(self.container)
        .find('.video_ui')
        .stop(true, true)
        .animate({ bottom: self.uiBottomOffset })
    var vidSkip = $(self.container).find('.video_skip')
    if (vidSkip.length > 0 && VideoPlayer.isMobile()) vidSkip.stop(true, true).animate({ bottom: '50px' })
    clearTimeout(self.videoUITimeout)
    if (self._isPlaying && offUI) {
        self.videoUITimeout = setTimeout(function() {
            self.hideVideoUI()
        }, 3000)
    }
    this._isUIHidden = false
    this.trigger(VideoPlayer.events.UI_SHOWN)
}

VideoPlayer.prototype.isMouseOverUI = function() {
    var self = this
    return $(self.container).find('.video_ui:hover').length > 0
}

VideoPlayer.prototype.hideVideoUI = function(mouseClick) {
    mouseClick = mouseClick || false
    var self = this

    if (!this.isMouseOverUI() || mouseClick) {
        //if it's triggered by click, set time out to prevent make sure mouseup event go after movemove
        if (mouseClick && this.playback_type == VideoPlayer.playbackTypes.FLAT && !this.isMouseOverUI()) {
            setTimeout(function() {
                self._hideVideoUI(60)
            }, 250)
        } else {
            if (!this.isMouseOverUI()) {
                this._hideVideoUI()
            }
        }
    } else {
        this.videoUITimeout = setTimeout(function() {
            self.hideVideoUI()
        }, 3000)
    }
}

VideoPlayer.prototype.restart = function() {}
VideoPlayer.prototype.play = function() {}
VideoPlayer.prototype.pause = function() {}
VideoPlayer.prototype.isPlaying = function() {
    return this._isPlaying
}

VideoPlayer.prototype.onPlay = function(cb) {
    this.on(VideoPlayer.events.PLAY, cb)
    return this
}

VideoPlayer.prototype.onPause = function(cb) {
    this.on(VideoPlayer.events.PAUSE, cb)
    return this
}

VideoPlayer.prototype.onFinish = function(cb) {
    this.on(VideoPlayer.events.FINISH, cb)
    return this
}

VideoPlayer.prototype.onFullscreen = function(cb) {
    this.on(VideoPlayer.events.FULLSCREEN, cb)
    return this
}

VideoPlayer.prototype.onUIHidden = function(cb) {
    this.on(VideoPlayer.events.UI_HIDDEN, cb)
    return this
}

VideoPlayer.prototype.onUIShown = function(cb) {
    this.on(VideoPlayer.events.UI_SHOWN, cb)
    return this
}

VideoPlayer.prototype.onError = function(cb) {
    this.on(VideoPlayer.events.ERROR, cb)
    return this
}

VideoPlayer.prototype.onReady = function(cb) {
    this.on(VideoPlayer.events.READY, cb)
    return this
}

VideoPlayer.prototype.onProgress = function(cb) {
    this.on(VideoPlayer.events.PLAY_PROGRESS, cb)
    return this
}

VideoPlayer.prototype.onBuffer = function(cb) {
    this.on(VideoPlayer.events.LOAD_PROGRESS, cb)
    return this
}

VideoPlayer.prototype.onSkip = function(cb) {
    this.on(VideoPlayer.events.SKIP, cb)
    return this
}

VideoPlayer.prototype.on = function(name, cb) {
    //add the callback to the name of the event
    this._eventEmitter.on(name, cb)
    return this
}

VideoPlayer.prototype.off = function(name, cb) {
    if (cb) {
        // split out just this function
        this._eventEmitter.off(name, cb)
    } else {
        // clear the whole list
        this._eventEmitter.removeEvent(name)
    }
    return this
}

VideoPlayer.prototype.trigger = function(name, args) {
    this._eventEmitter.trigger(name, [args])
    return this
}

VideoPlayer.prototype.getDOMId = function() {
    return 'video_' + this.videoIndex
}

VideoPlayer.prototype.getListenerDOMId = function() {
    return ''
}

VideoPlayer.prototype.destroy = function() {
    VideoPlayer.unbindUIEvents(this.getDOMId(), this.getListenerDOMId())

    //clears all listeners
    this._eventEmitter.removeAllListeners()

    if (this.container !== null) {
        this.container.innerHTML = ''
        this.container = null
    }
    VideoPlayer.players[this.getDOMId()] = null
}

VideoPlayer.prototype.showDragInstructionsExplicitly = function(options) {
    this._showInstructions(this.container, options)
}

//// Internal Event Handlers ////
VideoPlayer.prototype._onFullscreenCb = function() {
    this.trigger(VideoPlayer.events.FULLSCREEN)
}

VideoPlayer.prototype._onDragEnd = function() {
    this.trigger(VideoPlayer.events.DRAGEND, this)
}

VideoPlayer.prototype._onDragStart = function() {
    this.trigger(VideoPlayer.events.DRAGSTART, this)
}

VideoPlayer.prototype._onReadyCb = function() {
    this.trigger(VideoPlayer.events.READY, this)
    this._onProgress()
    this.setHD()
    this.trigger(VideoPlayer.events.UI_SHOWN, this)
}

VideoPlayer.prototype._onErrorCb = function() {
    this.trigger(VideoPlayer.events.ERROR, this)
}

VideoPlayer.prototype._onPlayCb = function() {
    this._isPlaying = true
    $(this.container)
        .find('.video_ui .playbutton')
        .addClass('play')
    /* This should be taken care of on the walkingtour rather than here */
    if (typeof DescriptionAudioController != 'undefined') {
        DescriptionAudioController.disableAudio()
    }
    this.showVideoUI(this.options.autoplay)
    this.setHD()
    this.trigger(VideoPlayer.events.PLAY)
}

VideoPlayer.prototype._onPauseCb = function() {
    this._isPlaying = false
    $(this.container)
        .find('.video_ui .playbutton')
        .removeClass('play')
    this.trigger(VideoPlayer.events.PAUSE)
}

VideoPlayer.prototype._onFinishCb = function(stay) {
    this._isPlaying = false
    $(this.container)
        .find('.video_ui .playbutton')
        .removeClass('play')
    this.showVideoUI(false)
    if (!stay) {
        this._onProgress({
            seconds: 0,
            duration: 0,
        })
    }
    this.trigger(VideoPlayer.events.FINISH)
}

/**
 * called whenever the video time changes
 * @param  {object}|Optional data {
 *                       seconds : number of seconds ellapsed,
 *                       duration : total length of video in seconds
 *                  }
 */
VideoPlayer.prototype._onProgress = function(data) {
    var self = this

    if (data === undefined) {
        var seconds = this.getCurrentTime()

        this.getDuration(function(duration) {
            self._updateProgress(seconds, duration)
        })
    } else {
        this._updateProgress(data.seconds, data.duration)
    }

    var buffered = this.getBuffered()
    $(this.container)
        .find('.buffer')
        .width(buffered * 100 + '%')

    this.trigger(VideoPlayer.events.LOAD_PROGRESS, {
        buffered: buffered,
    })
}

VideoPlayer.prototype.getProgressInfo = function() {
    var s = this._globalPlayer ? this.getCurrentTime() : 0,
        d = this._globalPlayer ? this.getDuration() : 0,
        p = this._globalPlayer ? 100 * (d == 0 ? 0 : s / d) : 0,
        b = this._globalPlayer ? 100 * this.getBuffered() : 0
    return {
        seconds: s,
        duration: d,
        percent: p,
        buffered: b,
    }
}

VideoPlayer.prototype._updateProgress = function(seconds, duration) {
    var percent = duration == 0 ? 0 : seconds / duration
    $(this.container)
        .find('.video_ui .playtime')
        .html(VideoPlayer.toTime(seconds))
    $(this.container)
        .find('.video_ui .video_progress .bar')
        .css('width', percent * 100 + '%')

    this.trigger(VideoPlayer.events.PLAY_PROGRESS, {
        seconds: seconds,
        duration: duration,
        percent: percent,
    })
}

VideoPlayer.prototype._onVolume = function(volume, button) {
    if (
        button &&
        $(this.container)
            .find('.video_ui .volume_container')
            .is(':visible')
    ) {
        return this._hideVolume()
    }

    this._showVolume(volume)
    this._setVolumeTimeout()
}

VideoPlayer.prototype._setVolumeTimeout = function() {
    var self = this
    clearTimeout(this._volumeTimeout)
    this._volumeTimeout = setTimeout(function() {
        self._hideVolume()
    }, 500)
}

VideoPlayer.prototype._clearVolumeTimeout = function() {
    clearTimeout(this._volumeTimeout)
}

VideoPlayer.prototype._showVolume = function(volume) {
    this._clearVolumeTimeout()
    if (typeof volume === 'undefined') {
        this.getVolume(function(v) {
            volume = v
        })
    }
    $(this.container)
        .find('.video_ui .volume_container')
        .stop(true, true)
        .fadeIn(500)
    $(this.container)
        .find('.video_ui .volume .bar')
        .css('height', volume * 100 + '%')
}

VideoPlayer.prototype._hideVolume = function() {
    return $(this.container)
        .find('.video_ui .volume_container')
        .stop(true, true)
        .fadeOut()
}

/*
     this function will hide the  video ui takes the animation time
     */
VideoPlayer.prototype._hideVideoUI = function(uiHideTime) {
    uiHideTime = uiHideTime || 425
    var self = this

    this._hideVolume()
    clearTimeout(self.videoUITimeout)
    $(this.container)
        .find('.video_ui')
        .animate({ bottom: '-140px' }, uiHideTime)
    var vidSkip = $(this.container).find('.video_skip')
    if (vidSkip.length > 0 && VideoPlayer.isMobile()) vidSkip.animate({ bottom: '-185px' }, 1000)
    this._isUIHidden = true
    this.trigger(VideoPlayer.events.UI_HIDDEN)
    this.hideQualities()
}

VideoPlayer.volumeFadeOut = function(id) {
    var player = VideoPlayer.getPlayer(id)
    player._volumeFadeOut()
}

VideoPlayer.prototype._volumeFadeOut = function() {
    var self = this
    $(self.container)
        .find('.video_ui .volume_container')
        .fadeOut(1000)
}
VideoPlayer.prototype._getMousePercent = function(e, vertical) {
    var ml,
        element = $(this.container).find('.' + this.mouse.down)[0],
        offset = element.getBoundingClientRect(),
        el,
        l = e.touches && e.touches[0] ? e.touches[0] : e
    l = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0] ? e.originalEvent.touches[0] : l
    if (e.type === 'touchend') {
        l = self.lastTouch
    }
    self.lastTouch = l
    var ret
    if (vertical) {
        ml = l.pageY
        el = offset.top
        ret = 1 - Math.max(0, Math.min(1, (ml - el) / offset.height))
    } else {
        ml = l.pageX
        el = offset.left
        ret = Math.max(0, Math.min(1, (ml - el) / offset.width))
    }
    return ret
}

VideoPlayer.prototype._onWindowResize = function(e) {
    var UIDom = $('#' + this.getDOMId())
        .parent()
        .find('.video_ui_overlay')
    if (VideoPlayer.isMobile()) {
        if (!UIDom.hasClass('mobile')) UIDom.addClass('mobile')
    } else if (UIDom.hasClass('mobile')) {
        UIDom.removeClass('mobile')
    }
}

VideoPlayer.prototype._onMouseMove = function(e) {
    var self = this
    this.toggleClickOK = false
    if (this.mouse.down) {
        var percent = this._getMousePercent(e, this.mouse.down === 'volume')
        if (this.mouse.down === 'video_progress') {
            self.getDuration(function(duration) {
                self._onProgress({
                    duration: duration,
                    seconds: duration * percent,
                    percent: percent,
                })
            })
        }
        if (this.mouse.down === 'volume') {
            this._onVolume(percent)
            this.setVolume(percent)
        }
    }

    if (this.playback_type === VideoPlayer.playbackTypes.FLAT && !VideoPlayer.isMobile()) {
        self.showVideoUI()
    }

    //dont hide the ui if mouse is moving while the video is playing
    clearTimeout(self.videoUITimeout)
    if (this._isPlaying) {
        self.videoUITimeout = setTimeout(function() {
            self.hideVideoUI()
        }, 3000)
    }
}

VideoPlayer.prototype._onFullscreen = function(e) {
    var self = this
    if (self.isFullscreen()) {
        setTimeout(function() {
            $(self.container)
                .addClass('fullscreen')
                .css({
                    width: '100%',
                    height: '100%',
                })
        })
    } else {
        $(self.container).removeClass('fullscreen')
    }
    self._onFullscreenCb && self._onFullscreenCb()
}

VideoPlayer.prototype._onMouseDown = function(e) {
    this.toggleClickOK = $(e.target).closest('.alt-media-player').length > 0
    // if something is clicked on outside the ui controls, hide volume
    var UIDom = $('#' + this.getDOMId())
        .parent()
        .find('.video_ui_overlay')
    if (!$.contains(UIDom[0], e.target)) this._hideVolume()
}

VideoPlayer.prototype._onMouseUp = function(e) {
    var self = this
    var isEventHandled = false
    if (self.mouse.down) {
        isEventHandled = self.mouse.down === 'video_progress' || self.mouse.down === 'volume'
        var percent = self._getMousePercent(e)
        if (self.mouse.down === 'video_progress') {
            self.getDuration(function(duration) {
                self.play()
                setTimeout(function() {
                    self.seek(duration * percent)
                }, 250)
            })
        }
    }
    if (!isEventHandled) {
        if (this.togglePausePlayOnClick()) {
            if (this.toggleClickOK) {
                this.togglePlaying()
                this.showVideoUI(!$(e.target).closest('.video_ui').length)
            }
            return
        } else if (this.toggleClickOK) {
            if (this._isUIHidden) {
                //show UI
                this.showVideoUI()
            } else {
                //hide UI
                this.hideVideoUI()
            }
        } else {
            if (this._isUIHidden && this.playback_type == VideoPlayer.playbackTypes.FLAT) {
                //show UI
                this.showVideoUI()
            } else {
                //hide UI
                self.hideVideoUI(true)
            }
        }
    }

    self.mouse.down = false
}

/*
 * Attach dragging instructions to player. They will only show once
 */
VideoPlayer.prototype._showInstructions = function(overlayContainer, options) {
    var that = this,
        vidOptions = options || {},
        isMobile = Browser.is('mobile')

    if (this.options.playback_type == VideoPlayer.playbackTypes.THREE_SIXTY) {
        window.Elements &&
            window.Elements.DraggingHint &&
            window.Elements.DraggingHint.create({
                id: 'videoPanoInstructions',
                elementWrapper: overlayContainer,
                displayDuration: isMobile ? 5000 : 3000,
                mountDelay: vidOptions.mountDelay || 2000,
                fullscreenOverlay: isMobile,
                onMount: function(overlay, onDestroy) {
                    Cookie.set('video-pano-instruction', '1', 2)

                    // on touch/mousedown, destroy overlay
                    overlay['onclick'] = function() {
                        onDestroy(overlay)
                    }
                },
                onDestroy: function(overlay) {
                    if (overlay && overlayContainer) {
                        that._hideInstructions(document.getElementById('videoPanoInstructions'), overlayContainer)

                        // try to autoplay video when destroying
                        // NOTE: do not try to autoplay on actual mobile
                        //       devices; this doesn't just ignore
                        //       autoplay events but queue them -- causing funny
                        //       behavior since play gets called extra times
                        //       when user finally clicks play
                        if (!that._isPlaying && !isMobile) {
                            that.play()
                        }
                    }
                },
            })
    }
}

VideoPlayer.prototype._hideInstructions = function(instructions, overlayContainer) {
    try {
        if (this.options.autoplay) {
            this.play()
        }
    } catch (e) {
        console.error('attempted to autoplay a video and error caught: ', e)
    }

    // for compatibility with legacy stuff
    if (instructions && instructions.fadeOut && instructions.remove) {
        instructions.fadeOut(function() {
            instructions.remove()
        })
    } // but normally now, simply remove child/fade it
    else if (instructions) {
        window.Elements &&
            window.Elements.DraggingHint &&
            window.Elements.DraggingHint.destroy({ element: instructions, fadeDuration: 500 })
    }
}

VideoPlayer.prototype._showiOSNotSupported = function(container) {
    var overlay = this._buildOverlay()
    overlay.getElementsByTagName('span')[0].innerText = 'iOS 8 or later required'
    container.appendChild(overlay)
}

VideoPlayer.prototype._buildOverlay = function() {
    var overlay = document.createElement('div'),
        div = document.createElement('div'),
        img = document.createElement('img'),
        text = document.createElement('span')

    img.style.opacity = '0.7'
    img.style.display = 'block'

    text.style.fontSize = '18pt'
    text.style.lineHeight = '32px'
    text.style.color = '#bbbbbb'

    overlay.style.position = 'absolute'
    overlay.id = 'videoPanoInstructions'
    overlay.style.width = '100%'
    overlay.style.height = '100%'
    overlay.style.top = '0px'
    overlay.style.left = '0px'
    overlay.style.background = 'rgba(0,0,0,0.8)'
    overlay.style.zIndex = this.instructionIndex

    div.style.position = 'absolute'
    div.style.maxHeight = '60%'
    div.style.webkitTransform = div.style.transform = 'translateX(-50%) translateY(-50%)'
    div.style.top = '35%'
    div.style.left = '50%'
    div.style.width = '255px'
    div.style.textAlign = 'center'

    div.appendChild(img)
    div.appendChild(text)
    overlay.appendChild(div)

    return overlay
}

VideoPlayer.toTime = function(seconds) {
    var time = seconds || 0,
        minutes = time / 60,
        seconds = Math.round((minutes - Math.floor(minutes)) * 60)

    minutes = Math.floor(minutes)
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    if (seconds < 10) {
        seconds = '0' + seconds
    }
    return minutes + ':' + seconds
}

/*
 * Embeds the player in the given container.
 */
VideoPlayer.prototype._embedPlayer = function(container, width, height) {
    var playerTemplate = this._getTemplate(),
        playerHTML = ''

    playerData.videoID = this.id
    playerData.width = width
    playerData.height = height
    playerData.autoplay = this._getAutoPlayVar(this.options.autoplay)
    playerData.domId = this.getDOMId()
    playerData.controls = this._getAutoPlayVar(this.controls)
    playerData.background = this._getAutoPlayVar(this.background)
    playerData.loop = this._getAutoPlayVar(this.loop)

    playerHTML = this._markup(playerTemplate, playerData)

    if (typeof container === 'string') {
        container = document.getElementById(container)
    }
    //eleToAppendTo.insertAdjacentHTML('beforeend', playerHTML);

    $(container).html(playerHTML)

    this.container = container

    var self = this

    return container
}

VideoPlayer.prototype._getAutoPlayVar = function(autoplay) {
    return autoplay ? 1 : 0
}

/**
 * shows the last end seconds of the video
 * @param  {float} end number of seconds to show from the end
 */
VideoPlayer.prototype.showEnd = function(end) {
    var self = this
    self.play()
    setTimeout(function() {
        self.getDuration(function(duration) {
            self.seek(Math.max(0, duration - end))
        })
    }, 500)
}

/**
 * all videos must include this template if they can be controlled by the video ui
 * @return {String} html to be used as a template
 */
VideoPlayer.prototype._getTemplate = function() {
    if (this.hideUI) return ''
    window.vpp = this
    var DOMId = this.getDOMId(),
        listenerDOMId = this.getListenerDOMId()
    return (
        "<div class='video_ui_overlay " +
        this.type +
        ' ' +
        (VideoPlayer.isMobile() ? 'mobile' : '') +
        "'>" +
        "<div class='video_ui' style='bottom: " +
        this.uiBottomOffset +
        ";'>" +
        "<div class='qualities'>" +
        "<div class='title'>Video Quality</div>" +
        "<div class='content'></div>" +
        '</div>' +
        "<div class='volume_container' style='display:none;'>" +
        "<div class='volume'>" +
        "<div class='bar'>" +
        "<div class='marker'></div>" +
        '</div>' +
        '</div>' +
        '</div>' +
        "<div class='left_panel'>" +
        "<div class='playbutton'>" +
        `<img src='${PLAY}' class='play'/>` +
        `<img src='${PAUSE} class='pause'/>` +
        '</div>' +
        "<span class='playtime'>00:00</span>" +
        '</div>' +
        "<div class='center_panel'>" +
        "<div class='video_progress'>" +
        "<div class='buffer'></div>" +
        "<div class='bar'>" +
        "<div class='marker'></div>" +
        '</div>' +
        '</div>' +
        '</div>' +
        "<div class='right_panel'>" +
        "<div class='audio_control'>" +
        `<img src='${AUDIO_ON}' class='audio'/>` +
        `<img src='${AUDIO_OFF}' class='audio audio_off'/>` +
        '</div>' +
        "<div class='settings settings_button'>" +
        `<img src='${SETTINGS}' class='settings'/>` +
        "<div class='hd'>HD</div>" +
        '</div>' +
        "<div class='fulscr'>" +
        `<img src='${FULLSCREEN}' class='fullscreen'/>` +
        `<img src='${FULLSCREEN_OFF}' class='fullscreen_exit'/>` +
        '</div>' +
        '</div>' +
        '</div>' +
        "<div class='video_skip'>Skip Intro</div>" +
        '</div>' +
        "<script type='text/javascript'>VideoPlayer.bindUIEvents('" +
        DOMId +
        "', '" +
        listenerDOMId +
        "');</script>"
    )
}

VideoPlayer.prototype.getQuality = function(cb) {
    cb('standard', [
        {
            display: 'Auto',
            value: 'auto',
        },
    ])
}

VideoPlayer.prototype.setHD = function() {
    var self = this
    setTimeout(function() {
        var hd = $(self.container).find('.hd')
        self.getQuality(function(quality, qualities) {
            for (var i = 0; i < qualities.length; i++) {
                if (qualities[i].value === quality) {
                    if (qualities[i].hd) {
                        hd.show()
                    } else {
                        hd.hide()
                    }
                    return
                }
            }
        })
    }, 250)
}

VideoPlayer.prototype.setQuality = function(quality) {
    this.setHD()
}

VideoPlayer.prototype.hideQualities = function() {
    var self = this,
        q = $(self.container).find('.qualities')
    clearTimeout(self.qualitiesTimeout)
    q.fadeOut()
    self.qualitiesTimeout = null
}

VideoPlayer.prototype.showQualities = function() {
    var self = this,
        q = $(self.container).find('.qualities')
    if (!self.qualitiesTimeout) {
        self.getQuality(function(quality, qualities) {
            if (qualities.length) {
                q.fadeIn()
                var content = q.find('.content').html('')
                for (var i = 0; i < qualities.length; i++) {
                    var item = $('<div>', {
                        onclick:
                            "javascript:VideoPlayer.quality('" + self.getDOMId() + "', '" + qualities[i].value + "')",
                        text: qualities[i].display,
                        class: qualities[i].value === quality ? 'selected' : '',
                    })
                    content.append(item)
                }
            }
        })
    }
    clearTimeout(self.qualitiesTimeout)
    self.qualitiesTimeout = setTimeout(function() {
        q.fadeOut()
        self.qualitiesTimeout = null
    }, 5000)
}

VideoPlayer.prototype.togglePlaying = function() {
    if (this._isPlaying) {
        this.pause()
    } else {
        this.play()
    }
}

VideoPlayer.prototype._addPlayerAPI = function(container, width, height) {}

VideoPlayer.prototype.isFullscreen = function() {
    return (
        (document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement) === this.getFullscreenElement()
    )
}

/**
 * makes this video player fullscreen, or exits fullscreen if already
 */
VideoPlayer.prototype.fullscreen = function() {
    var elem = this.getFullscreenElement()

    if (this.isFullscreen()) {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        }
    } else {
        var fse =
            document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement
        if (fse) {
            return
        }
        if (elem.requestFullscreen) {
            elem.requestFullscreen()
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        }
    }
}

VideoPlayer.prototype.getFullscreenElement = function() {
    return this.container
}

VideoPlayer.prototype._markup = function(html, data) {
    var m,
        i = 0,
        match = html.match(data instanceof Array ? /{{\d+}}/g : /{{\w+}}/g) || []

    while ((m = match[i++])) {
        html = html.replace(m, data[m.substr(2, m.length - 4)])
    }
    return html
}

VideoPlayer.prototype._loadScript = function(script, onLoad) {
    var el = document.createElement('script'),
        head = document.getElementsByTagName('head')[0]
    el.onload = onLoad
    el.src = script
    head.appendChild(el)
}

//this is good but more needs to be done
var AwsPlayer = function(options) {
    VideoPlayer.call(this, options)
}

AwsPlayer.prototype = Object.create(VideoPlayer.prototype)

AwsPlayer.prototype._getTemplate = function() {
    var template = VideoPlayer.prototype._getTemplate.call(this)

    var videoObject =
        '<video' +
        " id='{{domId}}'" +
        " width='{{width}}'" +
        " height='{{height}}'" +
        ' playsinline>' +
        " <source crossOrigin='anonymous'/>" +
        '</video>'

    return template + videoObject
}

AwsPlayer.prototype._initPlayer = function() {
    var playerTemplate = this._getTemplate(),
        playerHTML = ''

    playerData.videoID = this.id
    playerData.width = this.width
    playerData.height = this.height
    playerData.autoplay = this._getAutoPlayVar(this.options.autoplay)
    playerData.domId = this.getDOMId()
    playerData.controls = this._getAutoPlayVar(this.controls)
    playerData.background = this._getAutoPlayVar(this.background)
    playerData.loop = this._getAutoPlayVar(this.loop)

    playerHTML = this._markup(playerTemplate, playerData)

    if (typeof this.container === 'string') {
        this.container = document.getElementById(this.container)
    }

    $(this.container).append(playerHTML)

    var widthStr = this.width + '',
        calculatedWidth =
            widthStr[widthStr.length - 1].indexOf('%') == 0
                ? this.container.offsetWidth * (parseInt(widthStr) / 100)
                : parseInt(widthStr)

    var player = (this._globalPlayer = $('#' + this.getDOMId()))

    // Update quality based on container size rendered above in playerHTML.
    this._currentQuality = this._getBestQualityForWidth(this._supportedQualities, calculatedWidth)
    player.find('source').attr('src', this._getUrlForQuality(this._currentQuality))

    this._onFinishCb = this._onFinishCb.bind(this)
    this._onPlayCb = this._onPlayCb.bind(this)
    this._onPauseCb = this._onPauseCb.bind(this)
    this._onTimeUpdate = this._onTimeUpdate.bind(this)
    this._onProgress = this._onProgress.bind(this)

    player.on(VideoPlayer.events.ENDED, this._onFinishCb)
    player.on(VideoPlayer.events.PLAY, this._onPlayCb)
    player.on(VideoPlayer.events.PAUSE, this._onPauseCb)
    player.on(VideoPlayer.events.TIMEUPDATE, this._onTimeUpdate)

    if (this.options.autoplay && !this._isPlaying) {
        this.play()
    }
}

AwsPlayer.prototype._onTimeUpdate = function(e) {
    if (this._globalPlayer) {
        var percent = this._globalPlayer[0].currentTime / this._globalPlayer[0].duration

        this._loadedProgress = Math.max(this._loadedProgress || 0, percent)

        this._onProgress()

        if (this.loop) {
            if (e.duration - e.position < 0.25) {
                this.seek(0)
            }
        }
    }
}

AwsPlayer.prototype._getUrlForQuality = function(quality) {
    var url

    for (var index in this._supportedQualities) {
        var supportedQuality = this._supportedQualities[index]

        if (supportedQuality.value == quality) {
            url = supportedQuality.url
            break
        }
    }

    return url
}

AwsPlayer.prototype._getQualitySupport = function(cb) {
    cb(this._supportedQualities)
}

AwsPlayer.prototype._getBestQualityForWidth = function(qualities, width) {
    var closestWidth = qualities
        .map(function(quality) {
            return quality.width
        })
        .reduce(function(prev, curr) {
            return Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev
        })

    var closestQuality = qualities.find(function(quality) {
        return quality.width == closestWidth
    })

    return closestQuality.value
}

AwsPlayer.prototype._embedPlayer = function(container, width, height) {
    var self = this,
        api = new ApiResource(),
        options = {
            id: self.id,
            urlParams: {
                projection: VideoPlayer.projections.NONE,
            },
            cb: function(response) {
                //Make sure it's a valid response
                if (response.data.length > 0) {
                    var video = response.data[0],
                        qualities = video.renditions.map(function(rendition) {
                            return {
                                value: rendition.value,
                                display: rendition.display,
                                hd: rendition.hd,
                                url: api.stripDomain(rendition.url),
                                width: rendition.width,
                            }
                        })

                    //Setup my defaults
                    self._currentQuality = qualities[0].value
                    self._supportedQualities = qualities.reverse()

                    self.container = container
                    self.width = width
                    self.height = height
                    self._initPlayer()

                    self._onReadyCb()
                } else {
                    console.error('Failed to contact API')
                }
            },
        }

    api.loadVideo(options)

    return container
}

AwsPlayer.prototype.getQuality = function(cb) {
    var self = this
    self._getQualitySupport(function(qualities) {
        for (var i = 0; i < qualities.length; i++) {
            if (self._currentQuality === qualities[i].value) {
                cb(qualities[i].value, qualities)
            }
        }
    })
}

AwsPlayer.prototype.playVideo = function(url) {
    this.pause()

    this._globalPlayer.find('source')[0].src = url

    var currentTime = this.getCurrentTime()

    this.load()

    this.setCurrentTime(currentTime)

    this.play()
}

AwsPlayer.prototype.setQuality = function(quality) {
    var rendition
    for (var index in this._supportedQualities) {
        rendition = this._supportedQualities[index]
        if (rendition.value == quality) {
            this._currentQuality = rendition.value
            this.playVideo(rendition.url)
        }
    }

    VideoPlayer.prototype.setHD.call(this)
}

AwsPlayer.prototype.getVolume = function(callback) {
    if (this._globalPlayer && this._globalPlayer[0]) {
        callback(this._globalPlayer[0].volume)
    }
}

AwsPlayer.prototype.setVolume = function(percent) {
    if (this._globalPlayer && this._globalPlayer[0]) {
        VideoPlayer.prototype.setVolume.call(this, percent)
        this._globalPlayer[0].volume = percent
    }
}

AwsPlayer.prototype.getDuration = function(callback) {
    var duration = (this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].duration) || 0

    if (typeof callback == 'function') callback(duration)

    return duration
}

AwsPlayer.prototype.setCurrentTime = function(currentTime) {
    if (this._globalPlayer && this._globalPlayer[0]) {
        this._globalPlayer[0].currentTime = currentTime
    }
}

AwsPlayer.prototype.getCurrentTime = function() {
    return (this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].currentTime) || 0
}

AwsPlayer.prototype.play = function() {
    VideoPlayer.prototype.play.call(this)
    this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].play()
}

AwsPlayer.prototype.load = function() {
    this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].load()
}

AwsPlayer.prototype.pause = function() {
    this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].pause()
}

AwsPlayer.prototype.seek = function(seconds) {
    if (this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].currentTime) {
        this._globalPlayer[0].currentTime = seconds
    }
}

AwsPlayer.prototype.destroy = function() {
    VideoPlayer.prototype.destroy.call(this)
    if (this._globalPlayer) {
        this._globalPlayer.off(VideoPlayer.events.ENDED, this._onFinishCb)
        this._globalPlayer.off(VideoPlayer.events.PLAY, this._onPlayCb)
        this._globalPlayer.off(VideoPlayer.events.PAUSE, this._onPauseCb)
        this._globalPlayer.off(VideoPlayer.events.TIMEUPDATE, this._onTimeUpdate)
    }

    this._globalPlayer && this._globalPlayer[0] && this._globalPlayer[0].remove && this._globalPlayer[0].remove()
}

/*
 * YouTubePlayer for playing Youtube videos
 */

var YoutubePlayer = function(options) {
    VideoPlayer.call(this, options)
}

YoutubePlayer.prototype = Object.create(VideoPlayer.prototype)

YoutubePlayer.prototype.getCurrentTime = function() {
    return this._globalPlayer.getCurrentTime ? this._globalPlayer.getCurrentTime() : 0
}

/**
 * get the percent of the video that has been loaded
 * @return {Float} fraction of the video that has been loaded
 */
YoutubePlayer.prototype.getBuffered = function() {
    return this._globalPlayer.getVideoLoadedFraction ? this._globalPlayer.getVideoLoadedFraction() : 0
}

/**
 * get the hd and sd string configurations
 * @return {object} hash of quality to constant
 */
YoutubePlayer.prototype._getQualitySupport = function(callback) {
    function properCase(display) {
        display = display.replace('hd', 'HD')
        return display[0].toUpperCase() + display.slice(1)
    }

    var aq = this._globalPlayer.getAvailableQualityLevels ? this._globalPlayer.getAvailableQualityLevels() : [],
        qualities = [],
        not_hd = ['tiny', 'small', 'medium', 'large']
    for (var i = 0; i < aq.length; i++) {
        qualities.push({
            display: properCase(aq[i]),
            value: aq[i],
            hd: not_hd.indexOf(aq[i]) === -1,
        })
    }
    if (!qualities.length) {
        qualities.push({
            display: 'Auto',
            value: 'auto',
        })
    }
    callback(qualities)
}

YoutubePlayer.prototype.getQuality = function(cb) {
    var self = this
    self._getQualitySupport(function(qualities) {
        cb(self._globalPlayer.getPlaybackQuality ? self._globalPlayer.getPlaybackQuality() : 'auto', qualities)
    })
}

YoutubePlayer.prototype.setQuality = function(quality) {
    var self = this,
        seconds = self.getCurrentTime()

    self.pause()
    self.getDuration(function(duration) {
        self.state = {
            quality: quality,
            seconds: seconds,
            playing: self._isPlaying,
        }
        self.options.autoplay = self._isPlaying
        self._globalPlayer = null
        self.embedPlayer(self.container, '100%', '100%')
        self._onProgress()
    })

    VideoPlayer.prototype.setHD.call(this)
}

/**
 * sets the volume of the player using a percent
 * @param {Float} percent number between 0 and 1
 */
YoutubePlayer.prototype.setVolume = function(percent) {
    VideoPlayer.prototype.setVolume.call(this, percent)
    this._globalPlayer.setVolume(percent * 100)
}

/**
 * get the volume of the player as a percent
 * @param {Function} callback called with number between 0 and 1 as the argument
 */
YoutubePlayer.prototype.getVolume = function(callback) {
    callback(this._globalPlayer.getVolume() / 100)
}

YoutubePlayer.prototype.play = function() {
    VideoPlayer.prototype.play.call(this)

    this._globalPlayer.playVideo()
}

YoutubePlayer.prototype.pause = function() {
    VideoPlayer.prototype.pause.call(this)

    this._globalPlayer.pauseVideo && this._globalPlayer.pauseVideo()
}

YoutubePlayer.prototype.destroy = function() {
    if (this._globalPlayer !== null) {
        this._globalPlayer.destroy()
    }

    VideoPlayer.prototype.destroy.call(this)
}

YoutubePlayer.prototype._addPlayerAPI = function(container, width, height) {
    var scope = this
    if (!window.YT || typeof window.YT.Player !== 'function') {
        return setTimeout(function() {
            scope._addPlayerAPI(container, width, height)
        }, 100)
    }
    this._globalPlayer = new YT.Player(this.getDOMId(), {
        height: height,
        width: width,
        videoId: this.id,
        playerVars: {
            playlist: this.loop ? this.id : undefined,
            controls: this.controls, //VideoPlayer.isMobile() ? 1 : 0,
            showinfo: 0,
            rel: 0,
            wmode: 'transparent',
            loop: this._getAutoPlayVar(this.loop),
        },
        events: {
            onReady: function(event) {
                if (scope._onReadyCb !== null) {
                    scope._onReadyCb(scope)
                }
                if (scope.state) {
                    scope._globalPlayer.setPlaybackQuality &&
                        scope._globalPlayer.setPlaybackQuality(scope.state.quality)
                    scope.seek(scope.state.seconds)
                    if (scope.state.playing) {
                        scope.play()
                    } else if (scope.options.autoplay) {
                        scope.stop()
                    }
                }
                if (scope.options.autoplay) {
                    event.target.playVideo()
                }
            },
            onStateChange: function(event) {
                //Play
                if (event.data === YT.PlayerState.PLAYING && scope._onPlayCb !== null) {
                    scope._onPlayCb()
                }
                //Pause
                if (event.data === YT.PlayerState.PAUSED && scope._onPauseCb !== null) {
                    scope._onPauseCb(scope)
                }
                //Finished
                if (event.data === YT.PlayerState.ENDED && scope._onFinishCb !== null) {
                    scope._onFinishCb()
                }

                onPlayerStateChange.call(scope, event)
            },
        },
    })
}

/**
 * used for tracking youtube player playback
 * @param  {Event} event playback information
 */
function onPlayerStateChange(event) {
    var self = this
    if (event.data == YT.PlayerState.PLAYING) {
        self.interval = setInterval(function() {
            if (self._globalPlayer && self._globalPlayer.getCurrentTime) {
                var currentTime = self._globalPlayer.getCurrentTime()
                self._onProgress()
            } else {
                clearTimeout(self.interval)
            }
        }, 1000 / 20)
    } else {
        clearTimeout(self.interval)
    }
}

/**
 * moves the videos progress to the specified number of seconds
 * @param  {Float} seconds number of seconds to seek to
 */
YoutubePlayer.prototype.seek = function(seconds) {
    this._globalPlayer.seekTo && this._globalPlayer.seekTo(seconds)
}

/**
 * get the total length of the video in seconds
 * @param  {Function} callback with float representing total
 *                             length of the video in seconds
 */
YoutubePlayer.prototype.getDuration = function(callback) {
    var d = this._globalPlayer.getDuration ? this._globalPlayer.getDuration() : 0
    if (callback) callback()
    return d
}

YoutubePlayer.prototype._getTemplate = function() {
    if (this.options.accessPlayerAPI) {
        return (
            VideoPlayer.prototype._getTemplate.call(this) +
            '<div id="{{domId}}" class="video-player alt-media-player"></div>'
        )
    }
    return (
        VideoPlayer.prototype._getTemplate.call(this) +
        '<iframe id=\'{{domId}}\' class=\'video-player alt-media-player\' width="{{width}}" height="{{height}}" src="//www.youtube.com/embed/{{videoID}}?wmode=transparent&rel=0&loop={{loop}}&controls=0&rel=0"  frameborder="0" allowfullscreen></iframe>'
    )
}

/*
 * VimeoPlayer for playing Vimeo videos
 */

var VimeoPlayer = function(options) {
    VideoPlayer.call(this, options)
    this._currentTime = 0
}

VimeoPlayer.prototype = Object.create(VideoPlayer.prototype)

/**
 * get the percent of the video that has been loaded
 * @return {Float} fraction of the video that has been loaded
 */
VimeoPlayer.prototype.getBuffered = function() {
    return this._loadProgress
}

/**
 * sets the volume of the player using a percent
 * @param {Float} percent number between 0 and 1
 */
VimeoPlayer.prototype.setVolume = function(percent) {
    VideoPlayer.prototype.setVolume.call(this, percent)
    this._globalPlayer.api('setVolume', percent)
}

/**
 * get the volume of the player as a percent
 * @param {Function} callback called with number between 0 and 1 as the argument
 */
VimeoPlayer.prototype.getVolume = function(callback) {
    this._globalPlayer.api('getVolume', callback)
}

VimeoPlayer.prototype.restart = function() {
    VideoPlayer.prototype.restart.call(this)
    this._globalPlayer.api('unload')
}

VimeoPlayer.prototype.play = function() {
    VideoPlayer.prototype.play.call(this)
    this._globalPlayer.api('play')
}

VimeoPlayer.prototype.pause = function() {
    VideoPlayer.prototype.pause.call(this)
    this._globalPlayer.api('pause')
}

VimeoPlayer.prototype.destroy = function() {
    VideoPlayer.prototype.destroy.call(this)
}

/**
 * Indicates if video should toggle pause/play on click
 * If not clicking hide UI
 * @return boolean
 */
VideoPlayer.prototype.togglePausePlayOnClick = function() {
    return VideoPlayer.isMobile() ? true : false
}

VimeoPlayer.prototype._addPlayerAPI = function(container, width, height) {
    var self = this
    self._globalPlayer = $f($('#' + self.getDOMId())[0])
    //With background we want to hide controls but have volume enabled.
    self._globalPlayer.api('setVolume', 1)
    self._globalPlayer.addEvent(VideoPlayer.events.READY, function() {
        self._globalPlayer.addEvent(VideoPlayer.events.PLAY_PROGRESS, function(object) {
            self._currentTime = object.seconds
            self._onProgress(object)
        })
        self._globalPlayer.addEvent(VideoPlayer.events.PLAY, function() {
            self._onPlayCb()
        })
        self._globalPlayer.addEvent(VideoPlayer.events.LOAD_PROGRESS, function(e) {
            self._loadProgress = e.percent
        })
        self._globalPlayer.addEvent(VideoPlayer.events.PAUSE, function() {
            self._onPauseCb(self)
        })
        self._globalPlayer.addEvent(VideoPlayer.events.FINISH, function() {
            self._onFinishCb()
        })
        if (self.options.autoplay) {
            self.play()
        }
        self._onReadyCb()
    })
}

VimeoPlayer.prototype._getTemplate = function() {
    return (
        VideoPlayer.prototype._getTemplate.call(this) +
        "<iframe id='{{domId}}' class='video-player alt-media-player' src=\"https://player.vimeo.com/video/{{videoID}}?api=1&player_id={{domId}}&title=0&portrait=0&byline=0&badge=0&loop=0&share=0&" +
        (this.controls ? '' : 'background=1') +
        '" width="{{width}}" height="{{height}}" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
    )
}

/**
 * get the total length of the video in seconds
 * @param  {Function} callback with float representing total
 *                             length of the video in seconds
 */
VimeoPlayer.prototype.getDuration = function(callback) {
    var self = this
    if (!callback) return 0
    self._globalPlayer.api('getDuration', function(duration) {
        callback(duration)
    })
}

VimeoPlayer.prototype.getCurrentTime = function() {
    return this._currentTime
}

/**
 * moves the videos progress to the specified number of seconds
 * @param  {Float} seconds number of seconds to seek to
 */
VimeoPlayer.prototype.seek = function(seconds) {
    this._globalPlayer.api('seekTo', seconds)
}

var VRPlayer = function(options) {
    this._supportedQualities = []
    VideoPlayer.call(this, options)
    //this._currentQuality = "2880_30_10";
}

VRPlayer.prototype = Object.create(VideoPlayer.prototype)

/**
 * Indicates if video should toggle pause/play on click
 * If not clicking hide UI
 * @return boolean
 */
VRPlayer.prototype.togglePausePlayOnClick = function() {
    return false
}

/**
 * get the percent of the video that has been loaded
 * @return {Float} fraction of the video that has been loaded
 */
VRPlayer.prototype.getBuffered = function() {
    var duration = this.getDuration()
    if (duration == 0) return 0

    return this._globalPlayer.getLoadedProgress() / duration
}

VRPlayer.prototype.destroy = function() {
    this._globalPlayer && this._globalPlayer.destroy()

    VideoPlayer.prototype.destroy.call(this)
}

VRPlayer.prototype.getQuality = function(cb) {
    var self = this
    self._getQualitySupport(function(qualities) {
        for (var i = 0; i < qualities.length; i++) {
            if (self._currentQuality === qualities[i].value) {
                cb(qualities[i].value, qualities)
            }
        }
    })
}

VRPlayer.prototype._videoReady = function() {
    var instructions = $('#videoPanoInstructions')

    if (instructions.length == 0 && this.options && this.options.autoplay) {
        this.play()
    }

    if (this._onReadyCb !== null) {
        this._onReadyCb()
    }
}

VRPlayer.prototype._videoError = function() {
    var instructions = $('#videoPanoInstructions')

    if (this._onErrorCb !== null) {
        this._onErrorCb()
    }
}

VRPlayer.prototype._embedPlayer = function(container, width, height) {
    if (width.toString().indexOf('%') < 0) {
        width += 'px'
    }
    if (height.toString().indexOf('%') < 0) {
        height += 'px'
    }
    container = VideoPlayer.prototype._embedPlayer.call(this, container, width, height)

    if ((Browser.is('iphone') || Browser.is('ipad')) && Browser.getBrowserData().version < 8) {
        return this._showiOSNotSupported(container)
    }
    var self = this,
        api = new ApiResource(),
        supportsWebGL = Browser.can('webgl'),
        projections = supportsWebGL
            ? Object.values(VideoPlayer.projections)
            : Object.values(VideoPlayer.projections).filter(function(projection) {
                  return projection != VideoPlayer.projections.EASY
              })

    var urlParams = {
        projection: projections
            .map(function(val) {
                return val == '' ? "''" : val
            })
            .join(', '),
    }

    if (VideoPlayer.isMobile() && this.deviceGrade != DeviceGrades.A) {
        urlParams['maxWidth'] = 1024
        urlParams['maxHeight'] = 1024
    }

    var options = {
        id: self.id,
        urlParams: urlParams,
        cb: function(response) {
            //Make sure it's a valid response
            if (response.data.length > 0) {
                var video = response.data[0],
                    rendition = video.renditions[0],
                    //for safari we don't want the base url so its proxies throught the server.
                    // We know the url is non-issue for chrome so it's okay to not strip the domain
                    // from the url.
                    url = api.stripDomain(rendition.url),
                    qualities = video.renditions.map(function(rendition) {
                        return {
                            value: rendition.value,
                            display: rendition.display,
                            hd: rendition.hd,
                            url: url,
                        }
                    })

                //Setup my defaults
                self.projection = rendition.projection
                self._currentQuality = qualities[0].value
                self._supportedQualities = qualities.reverse()
                self._globalPlayer = new VRVideoPlayer({
                    videoid: self.id,
                    domId: self.getDOMId(),
                    source: url,
                    projection: self.projection,
                    autorotate: self.options.autorotate,
                    startFov: self.options.startFov,
                    autorotateSpeed: self.options.autoRotateSpeed,
                    accelerometerControls: self.options.accelerometerControls,
                    onReadyCb: self._videoReady.bind(self),
                    onPlayCb: self._onPlayCb.bind(self),
                    onErrorCb: self._videoError.bind(self),
                    onPauseCb: self._onPauseCb.bind(self),
                    onProgressCb: self._onProgress.bind(self),
                    onFinishCb: self._onFinishCb.bind(self),
                    onDragEndCb: self._onDragEnd.bind(self),
                    onDragStartCb: self._onDragStart.bind(self),
                })

                //Start the player
                if (self._globalPlayer.start() && !self.disableShowDragHintOnLoad) {
                    self._showInstructions(container)
                }
            } else {
                console.error('Failed to contact API')
            }
        },
    }

    api.loadVideo(options)

    return container
}

VRPlayer.prototype.getCurrentTime = function() {
    return (this._globalPlayer && this._globalPlayer.getCurrentTime()) || 0
}

VRPlayer.prototype.getDuration = function(callback) {
    var d = (this._globalPlayer && this._globalPlayer.getDuration()) || 0
    if (callback) callback(d)
    return d
}

VRPlayer.prototype.seek = function(seconds) {
    if (this._globalPlayer) this._globalPlayer.seek(seconds)
}

VRPlayer.prototype._getTemplate = function() {
    return VideoPlayer.prototype._getTemplate.call(this) + "<div id='{{domId}}' class='three-sixty-player' ></div>"
}

VRPlayer.prototype.setVolume = function(percent) {
    VideoPlayer.prototype.setVolume.call(this, percent)
    if (this._globalPlayer) this._globalPlayer.setVolume(percent)
}

VRPlayer.prototype.getVolume = function(callback) {
    callback(this._globalPlayer.getVolume())
}

VRPlayer.prototype.play = function() {
    if (this._globalPlayer) this._globalPlayer.play()
}

VRPlayer.prototype.pause = function() {
    if (this._globalPlayer) this._globalPlayer.pause()
}

VRPlayer.prototype.getListenerDOMId = function() {
    return this.getDOMId()
}

/**
 * get the hd and sd string configurations
 * @return {object} hash of quality to constant
 */
VRPlayer.prototype._getQualitySupport = function(cb) {
    cb(this._supportedQualities)
}

VRPlayer.prototype.setQuality = function(quality) {
    var rendition
    for (var index in this._supportedQualities) {
        rendition = this._supportedQualities[index]
        if (rendition.value == quality) {
            this._currentQuality = rendition.value
            this._globalPlayer.playVideo(rendition.url, this._globalPlayer.isPaused(), this.getCurrentTime())
        }
    }

    VideoPlayer.prototype.setHD.call(this)
}

VRPlayer.prototype.enableAccelerometerControls = function(enabled) {
    this._globalPlayer.enableAccelerometerControls(enabled)
}

export default VideoPlayer
